import {
    RESET_COACHES,
    GET_ALL_COACHES,
    GET_ALL_COACHES_SUCCESS,
    GET_ALL_COACHES_ERROR
} from '../constants/ActionTypes';

const INIT_COACHES_STATE = {
    allCoaches: [],
    allCoachLoader: false,
    error: null
}

export default (state = INIT_COACHES_STATE, action) => {
    switch (action.type) {
        case RESET_COACHES: {
            return {
                ...INIT_COACHES_STATE
            }
        }

        case GET_ALL_COACHES: {
            return {
                ...state,
                allCoachLoader: true
            }
        }
        case GET_ALL_COACHES_SUCCESS: {
            return {
                ...state,
                allCoaches: action.payload,
                allCoachLoader: false
            }
        }
        case GET_ALL_COACHES_ERROR: {
            return {
                ...state,
                error: action.payload,
                allCoachLoader: false
            }
        }
        default:
            return state;
    }
}